import {WicketLocaleOverride} from '../wicket-locale-override';

export interface WicketAgreement {
  title: string;
  content: string;
  language_code: string;
  is_required: boolean;
  locale_override: WicketLocaleOverride<'title' | 'content', string>[];
  extra_data: unknown;
  agreement_id: number;
  version_id: number;
  is_active: true;
  created_at: string;
}
